export default {"src":"/_next/static/media/ella-user-chat-icon.6cad589e.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};